import React, {useState, useEffect, useRef} from 'react';
import {Form, Modal} from 'antd';
import emiter, {
    _EVENTS,
} from '../../../../events';
import CarProdTable from "./car-prod";

type CommonGlobalPropsVO = {
    enums?: any
}

const SPModal: React.FC<CommonGlobalPropsVO> = props => {
    const { enums, } = props
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [title, setTitle] = useState('');
    const dataRef = useRef({});
    const configRef: any = useRef({});
    const [list, setList] = useState<any[]>([]);

    const openModal = (params: any) => {
        setList(params || [])
        dataRef.current = params || {};
        form.resetFields();
        setOpen(true);
        setDisabled(!!params.disabled);
        setTitle('关联商品');
    };

    const onClose = () => {
        form.resetFields();
        dataRef.current = {}
        setOpen(false);
        setDisabled(false);
        setTitle('');
    };

    const onOk = () => {
        const res = form.getFieldsValue();
        form
            .validateFields()
            .then(async (values) => {
                const formDate = form.getFieldsValue();
                onClose()
            })
            .catch(() => {});
    };


    useEffect(() => {
        emiter.on(_EVENTS.PRODUCT_PRICE.CANCEL_RULE.OPEN_MODEL, openModal);
        return () => {
            emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.CANCEL_RULE.OPEN_MODEL)
        }
    }, []);

    return (
        <Modal title={title} width={'70%'} footer={null} centered open={open} onOk={onOk} onCancel={onClose}>
            <Form form={form} labelCol={{ span: 8 }} disabled={disabled}>
                <CarProdTable list={list}></CarProdTable>
            </Form>
        </Modal>
    );
};

export default SPModal;
